export const boxStyle = { display: 'flex', flexDirection: 'column', gap: '0.25rem' };

export const typographyStyle = {
  fontWeight: 'bold',
  fontSize: '0.75rem',
  color: 'white',
  '@media (max-width: 600px)': {
    fontSize: '0.65rem',
  },
};

export const typographyStyle2 = {
  fontSize: '0.75rem',
  color: 'white',
  '@media (max-width: 600px)': {
    fontSize: '0.65rem',
  },
};

export const toolTipStyle = {
  fontSize: '0.75rem',
  backgroundColor: 'white',
  verticalAlign: 'middle',
  cursor: 'pointer',
  '@media (max-width: 600px)': {
    fontSize: '0.65rem',
  },
};

export const typographyStyle3 = {
  fontSize: '0.75rem',
  fontWeight: 'bold',
  display: 'inline-block',
  backgroundColor: 'inherit',
  cursor: 'pointer',
  borderRadius: '50%',
  border: '1.6px solid currentColor',
  margin: '0 0.25em',
  padding: '0.15em',
  color: 'inherit',
  '@media (max-width: 600px)': {
    fontSize: '0.65rem',
  },
};

export const labelStyle = {
  p: 0.5,
  mb: 0.5,
  '@media (max-width: 600px)': {
    fontSize: '0.65rem',
  },
};

export const typographyLabelStyle = {
  fontWeight: 'bold',
  fontSize: '0.75rem',
  '@media (max-width: 600px)': {
    fontSize: '0.65rem',
  },
};
